import { render } from "./RegistrySettingsPage.vue?vue&type=template&id=f3170624&scoped=true"
import script from "./RegistrySettingsPage.vue?vue&type=script&lang=js"
export * from "./RegistrySettingsPage.vue?vue&type=script&lang=js"

import "./RegistrySettingsPage.vue?vue&type=style&index=0&id=f3170624&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f3170624"]])

export default __exports__